"use strict";
exports.__esModule = true;
exports.magFromTo = exports.pairId = exports.formatPerGranularity = exports.parseFormattedDate = exports.formatCounterValueHashes = exports.formatCounterValueHour = exports.formatCounterValueDay = exports.datapointLimits = exports.incrementPerGranularity = void 0;
var HOUR = 60 * 60 * 1000;
var DAY = 24 * HOUR;
exports.incrementPerGranularity = {
    daily: DAY,
    hourly: HOUR
};
exports.datapointLimits = {
    daily: 9999 * DAY,
    hourly: 7 * DAY
};
/**
 * efficient implementation of YYYY-MM-DD formatter
 * @memberof countervalue
 */
var formatCounterValueDay = function (d) {
    return d.toISOString().slice(0, 10);
};
exports.formatCounterValueDay = formatCounterValueDay;
/**
 * efficient implementation of YYYY-MM-DDTHH formatter
 * @memberof countervalue
 */
var formatCounterValueHour = function (d) {
    return d.toISOString().slice(0, 13);
};
exports.formatCounterValueHour = formatCounterValueHour;
/**
 * full version of formatCounterValue*
 */
var formatCounterValueHashes = function (d) {
    var iso = d.toISOString();
    return {
        iso: iso,
        day: iso.slice(0, 10),
        hour: iso.slice(0, 13)
    };
};
exports.formatCounterValueHashes = formatCounterValueHashes;
var parseFormattedDate = function (str) {
    var full = str;
    switch (str.length) {
        case 10:
            full += "T00:00";
            break;
        case 13:
            full += ":00";
            break;
    }
    full += ":00.000Z";
    return new Date(full);
};
exports.parseFormattedDate = parseFormattedDate;
exports.formatPerGranularity = {
    daily: exports.formatCounterValueDay,
    hourly: exports.formatCounterValueHour
};
function pairId(_a) {
    var _b, _c;
    var from = _a.from, to = _a.to;
    var fromTicker = (_b = from.countervalueTicker) !== null && _b !== void 0 ? _b : from.ticker;
    var toTicker = (_c = to.countervalueTicker) !== null && _c !== void 0 ? _c : to.ticker;
    return "".concat(fromTicker, "-").concat(toTicker);
}
exports.pairId = pairId;
function magFromTo(from, to) {
    return Math.pow(10, (to.units[0].magnitude - from.units[0].magnitude));
}
exports.magFromTo = magFromTo;
//# sourceMappingURL=helpers.js.map